import React from 'react';
import { useAiCommandPalette } from '../context/AiCommandPaletteContext';

const Suggestions = () => {
  const { 
    defaultSuggestions, 
    showSuggestions, 
    isAskMode,
    isLoading,
    handleAiAsk
  } = useAiCommandPalette();

  // Don't show suggestions when in ask mode or when search is in progress
  if (isAskMode || !showSuggestions || isLoading) return null;

  // Only display 2-3 suggestions maximum
  const limitedSuggestions = defaultSuggestions.slice(0, 3);

  // Function to handle suggestion click - directly pass to handleAiAsk
  const handleSuggestionClick = (suggestion) => {
    handleAiAsk(suggestion);
  };

  return (
    <div className="my-4 relative z-50">
      <div className="flex gap-4 justify-center">
        {limitedSuggestions.map((suggestion, index) => (
          <button
            key={index}
            onClick={() => handleSuggestionClick(suggestion)}
            className="flex items-center bg-violet-100 dark:bg-violet-900/60 text-violet-700 dark:text-violet-300 text-xs rounded-lg px-3 py-2 h-8 whitespace-nowrap shadow-sm hover:bg-violet-200 dark:hover:bg-violet-800/70 hover:text-violet-900 dark:hover:text-violet-100 transition-all duration-200 hover:shadow-md hover:scale-[1.03] active:scale-[0.97] border border-violet-200/50 dark:border-violet-700/30"
          >
            {suggestion}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Suggestions; 